import { useState } from 'react';

export const useMenuBarMobile = () => {
  const [isSlideMenu, setIsSlideMenu] = useState({});

  /**
   * @desc 타켓팅한 메뉴의 상태 관리 (선택한 메뉴만 true, 나머지는 false)
   * @param {number} idx 타겟팅한 메뉴
   * @returns 메뉴의 슬라이드 업/다운 애니메이션 부여
   */
  const onHandleSubMenuToggle = (idx) => {
    setIsSlideMenu((prev) => {
      const newState = {};
      Object.keys(prev).forEach((key) => {
        newState[key] = false; // 모든 메뉴를 false로 설정
      });
      newState[idx] = !prev[idx]; // 선택한 메뉴만 상태 토글
      return newState;
    });
  };

  const onHandleSlideReset = () => {
    setIsSlideMenu({});
  };

  return {
    isSlideMenu,
    onHandleSubMenuToggle,
    onHandleSlideReset,
  };
};
